/**
 * Continuous recording tiles live under this key so they do not paint on the
 * timeline (Caliber only renders selected AI motion types). Host seek helpers
 * still use these segments for uninterrupted media playback.
 */
export const MOCK_ARCHIVE_SEGMENT_KEY = 'archive';
